import { render, staticRenderFns } from "./AmwayPayCard.vue?vue&type=template&id=50a57a93&scoped=true&"
import script from "./AmwayPayCard.vue?vue&type=script&lang=js&"
export * from "./AmwayPayCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a57a93",
  null
  
)

export default component.exports